import { Share2Icon } from '@radix-ui/react-icons'
import ExcelIcon from 'assets/excel-icon.svg?react'
import { Toast } from 'components/Toast'
import {
  GeckoBinnedDataBuffer,
  handleCreateExcelSheet,
} from 'features/dataLayers'
import React from 'react'
import styled from 'styled-components'
import {
  GeckoComponentDataFrame,
  GeckoComponentModel,
  GeckoInspection,
  GeckoMeasurementUnit,
} from 'types'

const ExcelDownloadButtonContainer = styled.div`
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`

const StyledExcelDownloadButton = styled.button<{ $disabled?: boolean }>`
  height: 2rem;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 1rem;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  border: none;
  border-radius: 0.25rem;
  color: ${({ theme }) => theme.forecast.text1};
  background-color: ${({ theme }) => theme.forecast.defaultButton};
  opacity: ${(props) => (props.$disabled ? '0.4' : '1.0')};

  & div {
    color: ${({ theme }) => theme.forecast.defaultText};
  }

  svg {
    color: ${({ theme }) => theme.forecast.icon1};
  }

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }

  &:active {
    background-color: ${({ theme }) => theme.forecast.activeButton};
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

export const ExcelDownloadButton: React.FC<{
  selectedInspection: GeckoInspection | undefined
  selectedCDF: GeckoComponentDataFrame | undefined
  siteName: string
  unitName: string
  organizationName: string
  selectedComponentName: string
  selectedComponentModel: GeckoComponentModel | undefined
  binnedDataBuffer: GeckoBinnedDataBuffer | undefined

  isCDFLoading: boolean
  getPreferredMeasurementUnit: (
    inputUnit: GeckoMeasurementUnit
  ) => GeckoMeasurementUnit
}> = ({
  selectedInspection,
  selectedCDF,
  siteName,
  unitName,
  organizationName,
  selectedComponentName,
  selectedComponentModel,
  binnedDataBuffer,
  isCDFLoading,
  getPreferredMeasurementUnit,
}) => {
  //----------------------------------------------------------------------------

  const [toastOpen, setToastOpen] = React.useState(false)
  const [isCreatingExcelSheet, setIsCreatingExcelSheet] = React.useState(false)

  return (
    <>
      <ExcelDownloadButtonContainer>
        <StyledExcelDownloadButton
          onClick={() =>
            handleCreateExcelSheet(
              selectedInspection,
              selectedCDF,
              siteName,
              unitName,
              organizationName,
              selectedComponentName,
              selectedComponentModel,
              setIsCreatingExcelSheet,
              setToastOpen,
              binnedDataBuffer,
              isCDFLoading,
              getPreferredMeasurementUnit
            )
          }
          $disabled={isCDFLoading || isCreatingExcelSheet}>
          <ExcelIcon width={16} height={16} />
          {isCreatingExcelSheet ? (
            <span>Exporting…</span>
          ) : (
            <span>Export to Excel</span>
          )}
          <Share2Icon strokeWidth={8} />
        </StyledExcelDownloadButton>
      </ExcelDownloadButtonContainer>
      <Toast
        title={'Download Not Available'}
        message={'The url for this file is not available.'}
        open={toastOpen}
        setOpen={setToastOpen}
      />
    </>
  )
}
